import $ from 'jquery';

let memoizedLocales;

export function getBundleFromJSON(selector = '#locales') {
    if (!memoizedLocales) {
        try {
            memoizedLocales = JSON.parse($(selector).html());
        } catch {
            //@TODO notify some logger service
            console.error('Locals not loaded');
        }
    }
    return memoizedLocales || {};
}

/**
 * Returns locale for a key with replacements.
 * @param {Object||Function} bundle - dictonary object or function to get it
 */
function getLocaleValue(bundleHandler) {
    const bundle = typeof bundleHandler === 'function' ? bundleHandler() : bundleHandler;
    return (localeKey, replacePairs, fallback) => {
        let str = bundle?.[localeKey];
        if (str && replacePairs instanceof Object) {
            for (let key of Object.keys(replacePairs)) {
                const regexp = new RegExp(`{${key}}`, 'g');
                str = str.replace(regexp, replacePairs[key]);
            }
        }
        return str || fallback || localeKey;
    };
}

export const getLocale = getLocaleValue(getBundleFromJSON);

export default getLocaleValue;
